import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageComponent } from '../../components/page/page.component';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceService } from 'src/app/general/services/device.service';
import { TitleComponent } from 'src/app/general/components/title/title.component';
import { LocalizationService } from 'src/app/general/services/localization.service';
import { MatCardModule } from '@angular/material/card';
import { TableLayoutComponent } from 'src/app/general/components/table-layout/table-layout.component';

@Component({
  selector: 'app-support-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    TranslateModule,
    TitleComponent,
    MatCardModule,
    TableLayoutComponent
  ],
  templateUrl: './support-page.component.html',
  styleUrls: ['./support-page.component.css']
})
export class SupportPageComponent {

  constructor(
      public deviceService:DeviceService,
      private localizationService: LocalizationService) {
  }

  public isSpanish(): boolean {
    return this.localizationService.isSpanish();
  }
}
